//Common service for dealing with small tables

app.factory(
    'HelperService', ['LocalStorage', 'Configuration', 'ApiService', 'Upload', '$rootScope', '$http', '$filter', '$window', HelperService]
);

function HelperService(LocalStorage, Configuration, ApiService, UploadServcie, $rootScope, $http, $filter, $window) {
    self.GetDescriptionById = GetDescriptionById;
    self.UpdateDescription = UpdateDescription;
    self.AddDescription = AddDescription;
    self.GetWorkflowStatusList = GetWorkflowStatusList;
    self.GetDistance = GetDistance;

    function GetDescriptionById(id, lang) {
        return ApiService.get('/api/descriptionAPI/GetDescriptionTranslation?id=' + id + "&lang=" + lang).then(handleSuccess, handleError('Error getting Description by id'));
    }

    self.GetDescriptionVm = function (id, lang) {
        return ApiService.get('/api/descriptionAPI/GetDescriptionVM?id=' + id + "&lang=" + lang)
            .then(handleSuccess, handleError('Error getting GetDescriptionVm by id'));
    }

    self.GetDescriptionVmWithSort = function (id, objectId, linkTypeId, qc, lang) {
        return ApiService.get('/api/descriptionAPI/GetDescriptionVmWithSort?id=' + id + "&objectId=" + objectId + "&linkTypeId=" + linkTypeId + "&qc=" + qc + "&lang=" + lang)
            .then(handleSuccess, handleError('Error getting GetDescriptionVmWithSort by id'));
    }

    self.GetAssociatedPlacesOnSideBar = function (objectId, linkTypeId, lang, loadInactif) {
        return ApiService.get('/api/helperAPI/GetAssociatedPlacesOnSideBar?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang + "&loadInactif=" + loadInactif)
            .then(handleSuccess, handleError('Error getting GetAssociatedPlacesOnSideBar by id'));
    }

    self.GetAssociatedContactsOnSideBar = function (objectId, linkTypeId, lang, loadInactif) {
        return ApiService.get('/api/helperAPI/GetAssociatedContactsOnSideBar?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang + "&loadInactif=" + loadInactif)
            .then(handleSuccess, handleError('Error getting GetAssociatedContactsOnSideBar by id'));
    }

    self.GetPlaceListOfCurrentZone = function (zoneId, lang) {
        return ApiService.get('/api/helperAPI/GetPlaceListOfCurrentZone?z=' + zoneId + "&lang=" + lang)
            .then(handleSuccess, handleError('Error getting GetPlaceListOfActiveZone by id'));
    }


    self.GetAssociatedZonesOnSideBar = function (objectId, linkTypeId, lang, loadInactif, psz) {
        return ApiService.get('/api/helperAPI/GetAssociatedZonesOnSideBar?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang + "&loadInactif=true" + "&psz=" + psz)
            .then(handleSuccess, handleError('Error getting GetAssociatedZonesOnSideBar by id'));
    }

    self.GetAssociatedFilesOnSideBar = function (objectId, linkTypeId, lang, loadInactif, psz) {
        return ApiService.get('/api/helperAPI/GetAssociatedFilesOnSideBar?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang + "&loadInactif=true" + "&psz=" + psz)
            .then(handleSuccess, handleError('Error getting GetAssociatedFilesOnSideBar by id'));
    }

    self.GetPlaceByCity = function (objectId, linkTypeId, cityId, lang) {
        return ApiService.get('/api/helperAPI/GetPlaceByCity?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&cityId=" + cityId + "&lang=" + lang + "&loadInactif=true")
            .then(handleSuccess, handleError('Error getting GetPlaceByCity'));
    }

    self.GetPlaceByCityForSteps = function (objectId, linkTypeId, lang, loadInactif) {
        return ApiService.get('/api/helperAPI/GetPlaceByCityForSteps?objectId=' + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang + "&loadInactif=" + loadInactif)
            .then(handleSuccess, handleError('Error getting GetPlaceByCity'));
    }

    self.GetMcdPlaceLiaisons = function (mcdChilds, mcdParents) {
        return ApiService.get('/api/helperAPI/GetMcdPlaceLiaisons?mcdChilds=' + mcdChilds + '&mcdParents=' + mcdParents)
            .then(handleSuccess, handleError('Error getting GetMcdPlaceLiaisons'));
    }

    self.GetProfessionList = function () {
        return ApiService.get('/api/helperAPI/GetProfessionList').then(handleSuccess, handleError('Error getting GetProfessionList'));
    }

    self.UpdateObjectPositionInZone = function (objectId, zoneId, oldPos, newPos, linkTypeId) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post('/api/zoneAPI/UpdateObjectPositionInZone?objectId=' + objectId + '&zoneId=' + zoneId + '&oldPos=' + oldPos + '&newPos=' + newPos + '&linkTypeId=' + linkTypeId)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    self.UpdatePlacePositionInItinerary = function (placeId, itiId, oldPos, newPos) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post('/api/itineraryAPI/UpdatePlacePositionInItinerary?placeId=' + placeId + '&itiId=' + itiId + '&oldPos=' + oldPos + '&newPos=' + newPos)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description  
    function UpdateDescription(Description) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(Description);
        var request = ApiService.post("/api/DescriptionApi/UpdateDescriptionTranslation?id=" + Description.DescriptionId, st)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update DescriptionVm (mode Consultation)
    self.UpdateDescriptionVm = function (DescriptionVm, linkTypeId) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(DescriptionVm);
        var request = ApiService.post("/api/DescriptionApi/UpdateDescriptionVm?id=" + DescriptionVm.Description.DescriptionId + "&linkTypeId=" + linkTypeId, st)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //AddDescriptionToClient
    self.AddDescriptionToClient = function (ClientList, descId) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(ClientList);
        var request = ApiService.post("/api/DescriptionApi/AddDescriptionToClient?id=" + descId, st)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    self.AddQualificationToDescription = function (QcList, descId) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(QcList);
        var request = ApiService.post("/api/DescriptionApi/AddQualificationToDescription?id=" + descId, st)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    self.UpdateDescriptionStatus = function (descId, lang, statusText) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/DescriptionApi/UpdateDescriptionTranslationStatus?id=" + descId + "&lang=" + lang + "&status=" + statusText)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    self.UpdateDescriptionPosition = function (objectId, descId, oldPos, newPos, linkTypeId) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/DescriptionApi/UpdateDescriptionPosition?objectId=" + objectId + "&desId=" + descId + "&oldPos=" + oldPos + "&newPos=" + newPos + "&linkTypeId=" + linkTypeId)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    function AddDescription(Description) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(Description);
        var request = ApiService.post("/api/DescriptionApi/AddNewDescriptionTranslation/", st).then(function (data) {
        })
        .then(
                function success(data) {
                    $rootScope.NewDescriptionTranslationIsAdded = true;
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.NewDescriptionTranslationIsAdded = false;
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save Qualification associées
    self.SaveQualificationAssociees = function (objectId, linkTypeId, lang, qcList) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(qcList);
        var request = ApiService.post("/api/SideBar/SaveQualificationAssociees?id=" + objectId + "&linkTypeId=" + linkTypeId + "&lang=" + lang, st)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Export InDesign
    self.ExportInDesign = function (ZoneId) {
        $rootScope.ShowIconLoading();        
        var request = ApiService.get("/api/helperAPI/ExportInDesign?z=" + ZoneId)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Save Job associé
    self.SaveJobAssocie = function (objectId, linkTypeId, professionTranslation) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/SideBar/SaveJobAssocie?id=" + objectId + "&linkTypeId=" + linkTypeId, professionTranslation)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
    
    self.GetExportHtml = function (z, lang) {
        return ApiService.get('/api/helperAPI/GetExportHtml?z=' + z + '&lang=' + lang).then(handleSuccess, handleError('Error getting export zone :' + z));
    }

    

    self.ExportWordGeneric = function (z, langinterface,lang, objecttype, search, gsearch, qc, SelectedId, mcd, sortkey, reverse) {
        //var request = ApiService.get("/api/helperAPI/ExportWord?url=" + s + "&lang=" + lang)
        var st = JSON.stringify(SelectedId);
        var request = ApiService.post("/api/helperAPI/ExportWordGeneric?z=" + z +'&langinterface='+langinterface+ '&lang=' + lang + '&objecttype=' + objecttype + '&search=' + search + '&gsearch=' + gsearch + "&qc=" + qc + "&mcd=" + mcd + "&sortkey=" + sortkey + "&reverse=" + reverse, st, 'arraybuffer')
       
        .then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: "application/octet-stream" });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if ("application/octet-stream" == headers["content-type"]) {
                        linkElement.setAttribute("download", filename);
                    }

                    linkElement.setAttribute('target', '_self');

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }
    self.ExportWord = function (s,urlconfig) {
        //var request = ApiService.get("/api/helperAPI/ExportWord?url=" + s + "&lang=" + lang)
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/helperAPI/ExportWord?url=' + s+'&urlconfig='+urlconfig,

            responseType: 'arraybuffer'
        })
        .then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: "application/octet-stream" });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if ("application/octet-stream" == headers["content-type"]) {
                        linkElement.setAttribute("download", filename);
                    }

                    linkElement.setAttribute('target', '_self');

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }
    // this function handle 4 types of object
    // 1 - simple : name : value;
    // 2 - array of object with true false  : [{id:1,actif:true},{}]
    // 3 - list of object of array with true fale : { {[{id:1,actif:true},{}]},{[]}}
    // 4 - Array of object no actif, take all values : ex slider min max [{mix:100,max:1500},{}]
    // 5 - Dictionary <string,string> 

    self.GetTypeValue = function (proval) {
        if (proval == "true" || proval == "false")
            return (proval === 'true');
        else if (isNaN(proval))
            return proval;
        else
            return +proval;
    }

    self.SplitSearchUrlParam = function (obj, params) {
        var proname;
        var proval;
        var values;
        if (params) {
            var param = params.split("|");
            for (i = 0; i < param.length; i++) {
                {
                    var p = param[i];
                    //if simple param 
                    if (p.indexOf(".") < 0 && p.indexOf("§") < 0 && p.indexOf(">") < 0 && p.indexOf("^") < 0 && p.indexOf("=") > 0) {
                        proname = p.split("=")[0];
                        proval = p.split("=")[1];
                        for (var key in obj) {
                            if (key == proname && proval) {
                                obj[key] = self.GetTypeValue(proval);

                            }
                        }
                    }
                        //if array : slider=#min-0;max-1000[#min-0;max-24[
                    else if (p.indexOf("§") > 0) {
                        proname = p.split("=")[0];
                        proval = p.split("=")[1];
                        values = proval.split('[');
                        for (var key in obj) {
                            if (key == proname) {
                                for (ii = 0; ii < obj[key].length; ++ii) {
                                    var j = 0;
                                    for (var k in obj[key][ii]) {
                                        if (typeof obj[key][ii][k] !== 'object') {
                                            if (values.length > ii) {
                                                obj[key][ii][k] = self.GetTypeValue(values[ii].replace("§", "").split(";")[j].split("-")[1]);
                                                j++;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                        //dictionary  :SearchValues=key-value;key-value
                    else if (p.indexOf(">") > 0) {
                        proname = p.split("=")[0];
                        proval = p.split("=")[1];
                        values = proval.split(';');
                        var j = 0;
                        //for (var k in  obj[proname]) {
                        for (j = 0; j < values.length; ++j)
                            //if (values.length>j )
                        {
                            obj[proname][values[j].split(">")[0]] = GetTypeValue(values[j].split(">")[1]);
                            //  j++;
                        }
                        //}
                    }
                        //ClassificationList = Classification.* Editorial.12; 24; *Product.* Rubric.* SubRubric.* Typology.* ServiceEquipement.*
                    else if (p.indexOf(".") > 0) {
                        proname = p.split("=")[0];
                        proval = p.split("=")[1];
                        values = proval.split('*');
                        var j = 0;
                        for (var k in obj[proname]) {
                            //ex:Editorial.12; 24
                            var objname = values[j].split(".")[0];
                            var objval = values[j].split(".")[1];
                            if (k == objname) {
                                j++;
                                if (objval) {
                                    //ex: each entry of editorial
                                    for (s = 0; s < obj[proname][k].length; ++s)
                                        //each last obj value, ex: {id:1,actif:false}
                                        for (var kp in obj[proname][k][s]) {
                                            for (jj = 0; jj < objval.split(";").length; ++jj)
                                                if (kp == "id" && obj[proname][k][s][kp] == objval.split(";")[jj]) {
                                                    obj[proname][k][s].actif = true;
                                                }
                                        }
                                }
                            }
                        }

                    }
                        //array of object with true false  : SelectedCityList[{id:1,actif:true},{}]  / SelectedCityList=^12;13;14
                    else if (p.indexOf("^") > 0) {
                        p = p.replace("^", "");
                        proname = p.split("=")[0];
                        proval = p.split("=")[1];
                        values = proval.split(';');

                        for (t = 0; t < obj[proname].length; ++t) {
                            for (var kt in obj[proname][t]) {
                                for (tt = 0; tt < values.length; ++tt)
                                    if (kt == "id" && obj[proname][t][kt] == values[tt]) {
                                        obj[proname][t].actif = true;
                                    }
                            }
                        }

                    }
                }
            }

        }
    }
    // this function handle 4 types of object
    // 1 - simple : name : value;
    // 2 - array of object with true false  : [{id:1,actif:true},{}]
    // 3 - list of object of array with true fale : { {[{id:1,actif:true},{}]},{[]}}
    // 4 - Array of object no actif, take all values : ex slider min max [{mix:100,max:1500},{}]
    // 5 - Dictionary <string,string> 
    self.GetSearchUrlParamV2 = function (obj) {
        var params = "";
        for (var key in obj) {
            // simple object : case 1*
            if (obj[key] !== null && typeof obj[key] !== 'object')
                params += "|" + key + "=" + obj[key];
            else {
                //array of object
                if (obj[key] != null && obj[key].length > 0) {
                    params += "|" + key + "=";
                    var firsttime = true;
                    for (i = 0; i < obj[key].length; ++i) {
                        var isonelevellist = 0;
                        for (k in obj[key][i]) {
                            //see if its simple object list
                            if (obj[key][i][k] != null && typeof obj[key][i][k] == 'object')
                                isonelevellist++;
                            if (k == "actif") {
                                isonelevellist = 0;
                                break;
                            }
                        }
                        //case 2*
                        if (isonelevellist == 0) {
                            // we get all the ids of the array separated by; 
                            for (var k in obj[key][i]) {
                                if (k == "actif")
                                    if (obj[key][i].actif == true)
                                        if (firsttime) {
                                            params += "^" + obj[key][i].id + ";";
                                            firsttime = false;
                                        }
                                        else
                                            params += obj[key][i].id + ";";
                            }
                            //clean last;
                            if (i == obj[key].length - 1)
                                params = params.slice(0, -1);
                        }
                        else {
                            //case 4* slider type, we get all value of the object separated by * for the array
                            found = false;
                            params += "§";
                            for (var k in obj[key][i]) {
                                if (obj[key][i][k] !== null && typeof obj[key][i][k] !== 'object') {
                                    found = true;


                                    params += k + "-" + obj[key][i][k] + ";";
                                }
                            }
                            //remove last ;
                            if (found)
                                params = params.slice(0, -1);
                            if (i < obj[key].length - 1)
                                params += "[";
                        }
                    }

                }
                else if (obj[key] !== null) {
                    params += "|" + key + "=";
                    var istwolevellist = 0;
                    for (var k in obj[key])
                        if (typeof obj[key][k] != 'object')
                            istwolevellist++;
                    // case 3*  
                    if (istwolevellist == 0) {
                        // list of object here
                        for (var k1 in obj[key]) {
                            params += k1 + ".";
                            var found = false;
                            for (i = 0; i < obj[key][k1].length; ++i) {
                                for (var k2 in obj[key][k1][i]) {
                                    if (k2 == "actif")
                                        if (obj[key][k1][i].actif == true) {
                                            found = true;
                                            params += obj[key][k1][i].id + ";";
                                        }
                                }
                            }
                            //remove last ;
                            if (found)
                                params = params.slice(0, -1);
                            params += "*";
                        }
                    }
                    else
                        //case 5 : dictionary string,string
                    {
                        for (var k in obj[key]) {
                            if (typeof obj[key][k] !== 'object')
                                params += k + ">" + obj[key][k] + ';';
                        }
                        params = params.slice(0, -1);

                    }
                }
            }
        }
        return  params;
    }

    self.GetSearchUrlParam = function (SearchVM) {
        var leadingZero = function (value) {
            if (value < 10) {
                return "0" + value.toString();
            }
            return value.toString();
        };

        var params = "&search=";
        if (SearchVM.isFilter == true) {

            //city
            var selected = $filter("filter")(SearchVM.CityListSelect, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|cityid-";
                angular.forEach(selected, function (value, key) {
                    params += value.id + ";";
                });
                params = params.slice(0, -1);
            }
            //district
            var selected = $filter("filter")(SearchVM.DistrictListSelect, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|districtid-";
                angular.forEach(selected, function (value, key) {
                    params += value.id + ";";
                });
                params = params.slice(0, -1);
            }
            //clid
            var selected = $filter("filter")(SearchVM.Client, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|clid-";
                angular.forEach(selected, function (value, key) {
                    params += value.id + ";";
                });
                params = params.slice(0, -1);
            }
            //status
            var selected = $filter("filter")(SearchVM.StatusList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|statusid-";
                angular.forEach(selected, function (value, key) {
                    params += value.id + ";";
                });
                params = params.slice(0, -1);
            }
            //lang
            var selected = $filter("filter")(SearchVM.LangList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|lang-";
                angular.forEach(selected, function (value, key) {
                    params += value.id + ";";
                });
                params = params.slice(0, -1);
            }
            //dates
            if (SearchVM.UpdateDate != null && SearchVM.UpdateDate != "0001-01-01T00:00:00") {
                var d = new Date(SearchVM.UpdateDate);
                var finaldate = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                params += "|updatedate-" + finaldate;
            }

            if (SearchVM.UpdateDateMax != null && SearchVM.UpdateDateMax != "0001-01-01T00:00:00") {
                var d = new Date(SearchVM.UpdateDateMax);
                var finaldate = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                params += "|updatedatemax-" + finaldate;
            }

            if (SearchVM.CreationDate != null && SearchVM.CreationDate != "0001-01-01T00:00:00") {
                var d = new Date(SearchVM.CreationDate);
                var finaldate = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                params += "|creationdate-" + finaldate;
            }

            if (SearchVM.CreationDateMax != null && SearchVM.CreationDateMax != "0001-01-01T00:00:00") {
                var d = new Date(SearchVM.CreationDateMax);
                var finaldate = (leadingZero(d.getDate()) + "/" + leadingZero(d.getMonth() + 1) + "/" + d.getFullYear());
                params += "|creationdatemax-" + finaldate;
            }

            if (SearchVM.DateCreationSearchType != null) {
                params += "|datecreationsearchtype-" + SearchVM.DateCreationSearchType;
            }
            if (SearchVM.DateUpdateSearchType != null) {
                params += "|dateupdatesearchtype-" + SearchVM.DateUpdateSearchType;
            }
            //Filters
            if (SearchVM.WithBio) {
                params += "|withbio-true";
            }
            if (SearchVM.Priority) {
                params += "|priority-1";
            }
            if (SearchVM.IsNew) {
                params += "|isnew-true";
            }
            //Author
            var selected = $filter("filter")(SearchVM.AuthorList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|author-";
                angular.forEach(selected, function (value, key) {
                    params += value.UserId + ";";
                });
                params = params.slice(0, -1);
            }
            //translator
            var selected = $filter("filter")(SearchVM.TranslatorList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|translator-";
                angular.forEach(selected, function (value, key) {
                    params += value.UserId + ";";
                });
                params = params.slice(0, -1);
            }
            //corrector
            var selected = $filter("filter")(SearchVM.CorrectorList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|corrector-";
                angular.forEach(selected, function (value, key) {
                    params += value.UserId + ";";
                });
                params = params.slice(0, -1);
            }
            //QualificationList
            var selected = $filter("filter")(SearchVM.QualificationList, { actif: true });
            if (selected != null && selected.length > 0) {
                params += "|qualification-";
                angular.forEach(selected, function (value, key) {
                    params += value.qcId + ";";
                });
                params = params.slice(0, -1);
            }

            if (SearchVM.ClassificationList) {
                //Rubric
                var selected = $filter("filter")(SearchVM.ClassificationList.Rubric, { actif: true });
                if (selected != null && selected.length > 0) {
                    params += "|rubric-";
                    angular.forEach(selected, function (value, key) {
                        params += value.classificationId + ";";
                    });
                    params = params.slice(0, -1);
                }

                //SubRubric

                var selected = $filter("filter")(SearchVM.ClassificationList.SubRubric, { actif: true });
                if (selected != null && selected.length > 0) {
                    params += "|subrubric-";
                    angular.forEach(selected, function (value, key) {
                        params += value.classificationId + ";";
                    });
                    params = params.slice(0, -1);
                }

                //Typology
                var selected = $filter("filter")(SearchVM.ClassificationList.Typology, { actif: true });
                if (selected != null && selected.length > 0) {
                    params += "|typologie-";
                    angular.forEach(selected, function (value, key) {
                        params += value.classificationId + ";";
                    });
                    params = params.slice(0, -1);
                }
                //ServiceEquipement
                var selected = $filter("filter")(SearchVM.ClassificationList.ServiceEquipement, { actif: true });
                if (selected != null && selected.length > 0) {
                    params += "|serviceequipment-";
                    angular.forEach(selected, function (value, key) {
                        params += value.classificationId + ";";
                    });
                    params = params.slice(0, -1);
                }

                //Editorial
                var selected = $filter("filter")(SearchVM.ClassificationList.Editorial, { actif: true });
                if (selected != null && selected.length > 0) {
                    params += "|editorial-";
                    angular.forEach(selected, function (value, key) {
                        params += value.classificationId + ";";
                    });
                    params = params.slice(0, -1);
                }
            }
            //price
            if (SearchVM.slider) {
                if ((SearchVM.slider != null) && (SearchVM.slider.length > 0) && (SearchVM.slider[0].min > 0 || SearchVM.slider[0].max < 1000)) {
                    params += "|price-" + SearchVM.slider[0].min + ";" + SearchVM.slider[0].max;
                }

                if ((SearchVM.slider != null) && (SearchVM.slider.length > 0) && (SearchVM.slider[1].min > 0 || SearchVM.slider[1].max < 24)) {
                    params += "|hours-" + SearchVM.slider[1].min + ";" + SearchVM.slider[1].max;
                }
            }


        }
        //Add Global Search
        if (SearchVM != null && SearchVM.GlobalSearch != null && SearchVM.GlobalSearch.SearchValues != null) {
            params += "&gsearch=";
            for (var index in SearchVM.GlobalSearch.SearchValues) {
                params += "|" + index + "-" + SearchVM.GlobalSearch.SearchValues[index];
            }
        }
        if (params == "&search=")
            params = "";
        if (params.indexOf("=|") != -1)
            params = params.replace("=|", "=");
        if (params.indexOf(";|") != -1)
            params = params.replace(";|", "|");

        return params;
    }

    function GetWorkflowStatusList(lang) {
        return ApiService.get('/api/helperAPI/GetWorkflowStatusList?lang=' + lang).then(handleSuccess, handleError('Error getting StatusList'));
    }

    function GetDistance(geo1, geo2) {
        return ApiService.get('/api/helperAPI/GetDistance?geo1=' + JSON.stringify(geo1) + "&geo2=" + JSON.stringify(geo2));
    }

    // private functions

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }

    // [Lam Hong 13-Jan-2026] LVCG-213: [Places list export] Integrate existing python place listing to BO
    self.ExportExcel = function (zoneId) {
        //var request = ApiService.get("/api/helperAPI/ExportWord?url=" + s + "&lang=" + lang)
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/helperAPI/ExportExcel?zoneid=' + zoneId,
            responseType: 'arraybuffer'
        })
            .then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: "application/octet-stream" });

                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        if ("application/octet-stream" == headers["content-type"]) {
                            linkElement.setAttribute("download", filename);
                        }

                        linkElement.setAttribute('target', '_self');

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            });
    }

    return self;
}